import React from 'react'
import ReactDOM from 'react-dom'
import html2pdf from 'html2pdf.js'

import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider'
import { ThemeProvider } from 'styled-components'
import { theme } from '../../Assets/Styles/theme'
import { muiTheme } from '../../Assets/Styles/muiTheme'

/**
 * @param {Object} args
 * @param {function} args.renderContent Function receives onInit function as an argument
 * and returns ReactNode that will be rendered
 * @param {boolean} args.delayedRender will wait for onInit function to be called
 *  before making a print
 * @param {boolean} args.title title of the printed file
 */
export default ({ renderContent, delayedRender, title = 'Quote' }) => {
  let resolveDefer = null
  const defer = new Promise(resolve => {
    resolveDefer = resolve
  })

  const div = document.createElement('div')

  const onInit = () => {
    setTimeout(() => {
      printAsPDF(div, title)
      resolveDefer()
    }, 10000)
  }

  ReactDOM.render(
    <ThemeProvider theme={theme}>
      <MuiThemeProvider muiTheme={muiTheme}>
        {renderContent({ onInit })}
      </MuiThemeProvider>
    </ThemeProvider>,
    div,
  )

  if (!delayedRender) onInit()

  return defer
}

export const printAsPDF = (element, title = 'Quote') => {
  // There is an issue with `html2pdf` library.
  // It will add margins to PDF if page is scrolled.
  // Scrolling top before printing PDF should solve that issues
  window.scrollTo(0, 0)

  const opt = {
    margin: 1, //1 cm of margins. Uses units from `jsPDF.unit`
    filename: `${title}.pdf`,
    image: { type: 'jpeg', quality: 0.98 },
    html2canvas: {
      scale: 2, //render canvas image in higher quality
      allowTaint: true, //load images from another sources
      useCORS: true, //attempt to load media via CORS
    },
    jsPDF: {
      orientation: 'portrait',
      unit: 'cm',
      format: 'a4',
    },
    pagebreak: { before: ['#page-break-before'], avoid: 'img' },
  }

  html2pdf()
    .from(element)
    .set(opt)
    .save()
}
